import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import FormInputText from '../../../common/Forms/FormTextField';
import { useForm, useWatch } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {
  EPISODE_QUALITY_ASSURANCE_UPDATE_URL,
  fieldRequired,
  QAOptions,
} from '../../../../constants';
import { postStopApi, setStopApi } from '../../../../services/StopApi/StopApi';
import FormInputRadio from '../../../common/Forms/FormRadio';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import {
  // setReviewDate,
  // setLastReviewDate,
  // setNextReviewDate,
  setQuestion1,
  setQuestion2,
  setQuestion3,
  setQuestion4,
  setQuestion5,
  setQuestion6,
  setQuestion7,
  setQuestion8,
  setQuestion9,
  setQuestion10,
  setQuestion11,
  setQuestion13,
  setQuestion14,
  setQuestion15,
  setExceptionComments,
  setFollowUpComments,
  // setDateCreated,
  // setDateEdited,
  setReviewCreatedBy,
  setEditedBy,
} from '../../../../redux/episode/qualityAssuranceTab/qualityAssuranceDetail/qualityAssuranceDetailSlice';
import FormSuccess from '../../../common/Forms/FormSuccess';
import {
  DialogHeader,
  DialogHeading,
  ButtonWrapper,
  CancelButton,
  SaveButton,
} from '../../Episode.Styled';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
// import _ from 'lodash';

const schema = yup.object().shape({
  question1: yup.string().required(fieldRequired),
  question2: yup.string().required(fieldRequired),
  question3: yup.string().required(fieldRequired),
  question4: yup.string().required(fieldRequired),
  question5: yup.string().required(fieldRequired),
  question6: yup.string().required(fieldRequired),
  question7: yup.string().required(fieldRequired),
  question8: yup.string().required(fieldRequired),
  question9: yup.string().required(fieldRequired),
  question10: yup.string().required(fieldRequired),
  question11: yup.string().required(fieldRequired),
  question13: yup.string().required(fieldRequired),
  question14: yup.string().required(fieldRequired),
  question15: yup.string().required(fieldRequired),
});

const QualityAssuranceDialog = (props) => {
  const { open, setOpen, openBackdrop, authToken, episodeId, fetchData } =
    props;
  const [formSuccess, setFormSuccess] = useState(false);
  const [isNewQualityAssurance, setIsNewQualityAssurance] = useState(false);
  const dispatch = useDispatch();

  const qualityAssuranceDetailForm = useSelector(
    (state) => state?.qualityAssuranceDetailForm
  );

  const qualityAssuranceReferenceData = useSelector(
    (state) => state?.qualityAssuranceReferenceData
  );

  const defaultValue = {
    QualityAssuranceReviewId:
      qualityAssuranceDetailForm?.QualityAssuranceReviewId,
    question1: qualityAssuranceDetailForm?.question1,
    question2: qualityAssuranceDetailForm?.question2,
    question3: qualityAssuranceDetailForm?.question3,
    question4: qualityAssuranceDetailForm?.question4,
    question5: qualityAssuranceDetailForm?.question5,
    question6: qualityAssuranceDetailForm?.question6,
    question7: qualityAssuranceDetailForm?.question7,
    question8: qualityAssuranceDetailForm?.question8,
    question9: qualityAssuranceDetailForm?.question9,
    question10: qualityAssuranceDetailForm?.question10,
    question11: qualityAssuranceDetailForm?.question11,
    question13: qualityAssuranceDetailForm?.question13,
    question14: qualityAssuranceDetailForm?.question14,
    question15: qualityAssuranceDetailForm?.question15,
    exceptionComments: qualityAssuranceDetailForm?.exceptionComments,
    followUpComments: qualityAssuranceDetailForm?.followUpComments,
    reviewCreatedBy: qualityAssuranceDetailForm?.reviewCreatedBy?.value,
    editedBy: qualityAssuranceDetailForm?.editedBy?.value,
    dateCreated: qualityAssuranceDetailForm?.dateCreated,
    dateEdited: qualityAssuranceDetailForm?.dateEdited,
  };
  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(schema),
  });
  const { handleSubmit, reset, control, setValue, watch, register, formState } =
    useFunction;
  const { isValid, dirtyFields, errors } = formState;

  useEffect(() => {
    reset(defaultValue);
  }, [
    defaultValue.QualityAssuranceReviewId,
    defaultValue.question1,
    defaultValue.question2,
    defaultValue.question3,
    defaultValue.question4,
    defaultValue.question5,
    defaultValue.question6,
    defaultValue.question7,
    defaultValue.question8,
    defaultValue.question9,
    defaultValue.question10,
    defaultValue.question11,
    defaultValue.question13,
    defaultValue.question14,
    defaultValue.question15,
    defaultValue.exceptionComments,
    defaultValue.followUpComments,
    defaultValue.reviewCreatedBy,
    defaultValue.editedBy,
    defaultValue.dateCreated,
    defaultValue.dateEdited,
  ]);

  const reviewCreatedBy = useWatch({
    control,
    name: 'reviewCreatedBy',
  });

  const reviewCreatedById = qualityAssuranceReferenceData?.userList?.filter(
    (item) => (item.value === reviewCreatedBy ? item.id : '')
  );
  const reviewCreatedByIdValues = {
    id: reviewCreatedById[0]?.id,
    value: reviewCreatedById[0]?.value,
  };

  const editedBy = useWatch({
    control,
    name: 'editedBy',
  });

  const editedById = qualityAssuranceReferenceData?.userList?.filter((item) =>
    item.value === editedBy ? item.id : ''
  );
  const editedByIdValues = {
    id: editedById[0]?.id,
    value: editedById[0]?.value,
  };

  useEffect(() => {
    dispatch(setReviewCreatedBy(reviewCreatedByIdValues));
    dispatch(setEditedBy(editedByIdValues));
  }, [reviewCreatedBy, editedBy]);

  const handleClose = () => {
    setOpen(false);
    reset(defaultValue);
  };

  const onSubmit = () => {
    const url = `${EPISODE_QUALITY_ASSURANCE_UPDATE_URL}/${episodeId}/QAReviews`;
    const payload = {
      reviewCreatedById: qualityAssuranceDetailForm?.reviewCreatedBy?.id,
      editedById: qualityAssuranceDetailForm?.editedBy?.id,
      QualityAssuranceReviewId:
        qualityAssuranceDetailForm?.QualityAssuranceReviewId,
      reviewDate:
        qualityAssuranceDetailForm?.reviewDate === '-'
          ? null
          : qualityAssuranceDetailForm?.reviewDate,
      lastReviewDate:
        qualityAssuranceDetailForm?.lastReviewDate === '-'
          ? null
          : qualityAssuranceDetailForm?.lastReviewDate,
      nextReviewDate:
        qualityAssuranceDetailForm.nextReviewDate === '-'
          ? null
          : qualityAssuranceDetailForm?.nextReviewDate,
      question1: qualityAssuranceDetailForm?.question1,
      question2: qualityAssuranceDetailForm?.question2,
      question3: qualityAssuranceDetailForm?.question3,
      question4: qualityAssuranceDetailForm?.question4,
      question5: qualityAssuranceDetailForm?.question5,
      question6: qualityAssuranceDetailForm?.question6,
      question7: qualityAssuranceDetailForm?.question7,
      question8: qualityAssuranceDetailForm?.question8,
      question9: qualityAssuranceDetailForm?.question9,
      question10: qualityAssuranceDetailForm?.question10,
      question11: qualityAssuranceDetailForm?.question11,
      question13: qualityAssuranceDetailForm?.question13,
      question14: qualityAssuranceDetailForm?.question14,
      question15: qualityAssuranceDetailForm?.question15,
      exceptionComments: qualityAssuranceDetailForm?.exceptionComments,
      followUpComments: qualityAssuranceDetailForm?.followUpComments,
      dateCreated: qualityAssuranceDetailForm?.dateCreated,
      dateEdited: new Date(),
    };
    const authorization = authToken;
    if (qualityAssuranceDetailForm?.newQualityAssurance) {
      const payload = {
        reviewCreatedById: 17981,
        editedById: 17981,
        // QualityAssuranceReviewId:
        //   qualityAssuranceDetailForm?.QualityAssuranceReviewId,
        reviewDate: new Date(),
        lastReviewDate:
          qualityAssuranceDetailForm?.lastReviewDate === ''
            ? null
            : qualityAssuranceDetailForm?.lastReviewDate,
        nextReviewDate:
          qualityAssuranceDetailForm.nextReviewDate === ''
            ? null
            : qualityAssuranceDetailForm?.nextReviewDate,
        question1: qualityAssuranceDetailForm?.question1,
        question2: qualityAssuranceDetailForm?.question2,
        question3: qualityAssuranceDetailForm?.question3,
        question4: qualityAssuranceDetailForm?.question4,
        question5: qualityAssuranceDetailForm?.question5,
        question6: qualityAssuranceDetailForm?.question6,
        question7: qualityAssuranceDetailForm?.question7,
        question8: qualityAssuranceDetailForm?.question8,
        question9: qualityAssuranceDetailForm?.question9,
        question10: qualityAssuranceDetailForm?.question10,
        question11: qualityAssuranceDetailForm?.question11,
        question13: qualityAssuranceDetailForm?.question13,
        question14: qualityAssuranceDetailForm?.question14,
        question15: qualityAssuranceDetailForm?.question15,
        exceptionComments: qualityAssuranceDetailForm?.exceptionComments,
        followUpComments: qualityAssuranceDetailForm?.followUpComments,
        dateCreated: new Date(),
        dateEdited: new Date(),
      };
      postStopApi({ url, payload, authorization }).then((response) => {
        console.log(response);
        if (response.succeeded === true) {
          fetchData();
          setFormSuccess(true);
          setIsNewQualityAssurance(true);
          // dispatch(setRefreshEpisodeParticipant(true));
          // setTimeout(() => {
          //   dispatch(setRefreshEpisodeParticipant(false));
          // }, 1000);
        }
      }).catch((e) => alert(e));
    } else {
      setStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          fetchData();
          setFormSuccess(true);
          // dispatch(setRefreshEpisodeParticipant(true));
          // setTimeout(() => {
          //   dispatch(setRefreshEpisodeParticipant(false));
          // }, 1000);
        }
      }).catch((e) => alert(e));
    }
    setOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: {
            maxWidth: 'unset',
            width: '800px',
            maxHeight: '90vh',
            '&::-webkit-scrollbar': { display: 'none' },
          },
        }}
      >
        {openBackdrop ? (
          <Backdrop
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={openBackdrop}
          >
            <CircularProgress />
          </Backdrop>
        ) : (
          <>
            <DialogHeader>
              <DialogHeading variant='h5'>
                Quality Assurance Questions
              </DialogHeading>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </DialogHeader>
            <Grid
              container
              spacing={2}
              style={{ padding: '10px 40px', marginTop: '0px' }}
            >
              {/* <FormInputText
                name='QualityAssuranceReviewId'
                control={control}
                type='text'
                disabled={true}
                label='Quality Assurance Review Id'
                // register={register('actId', {
                //    onChange: (e) => dispatch(setActId(e.target.value))
                // })}
              /> */}
              <FormInputRadio
                name='question1'
                control={control}
                options={QAOptions}
                label='1. Realease of Information from SAP ?'
                errors={!!errors.question1}
                helperText={errors?.question1?.message}
                register={register('question1', {
                  onChange: (e) =>
                    dispatch(setQuestion1(Number.parseInt(e.target.value))),
                })}
              />
              <FormInputRadio
                name='question2'
                control={control}
                options={QAOptions}
                label='2. Is the Participant Profile completed ?'
                errors={!!errors.question2}
                helperText={errors?.question2?.message}
                register={register('question2', {
                  onChange: (e) =>
                    dispatch(setQuestion2(Number.parseInt(e.target.value))),
                })}
              />
              <FormInputRadio
                name='question3'
                control={control}
                options={QAOptions}
                label='3. Substance Abuse Services Coordination Plan (CDC 1868) ?'
                errors={!!errors.question3}
                helperText={errors?.question3?.message}
                register={register('question3', {
                  onChange: (e) =>
                    dispatch(setQuestion3(Number.parseInt(e.target.value))),
                })}
              />
              <FormInputRadio
                name='question4'
                control={control}
                options={QAOptions}
                label='4. Initial Referral ?'
                errors={!!errors.question4}
                helperText={errors?.question4?.message}
                register={register('question4', {
                  onChange: (e) =>
                    dispatch(setQuestion4(Number.parseInt(e.target.value))),
                })}
              />
              <FormInputRadio
                name='question5'
                control={control}
                options={QAOptions}
                label='5. Realease of Information from Community Based Provider ?'
                errors={!!errors.question5}
                helperText={errors?.question5?.message}
                register={register('question5', {
                  onChange: (e) =>
                    dispatch(setQuestion5(Number.parseInt(e.target.value))),
                })}
              />
              <FormInputRadio
                name='question6'
                control={control}
                options={QAOptions}
                label='6. Is there an Authorization for each treatment episode ?'
                errors={!!errors.question6}
                helperText={errors?.question6?.message}
                register={register('question6', {
                  onChange: (e) =>
                    dispatch(setQuestion6(Number.parseInt(e.target.value))),
                })}
              />
              <FormInputRadio
                name='question7'
                control={control}
                options={QAOptions}
                label='7. Admission/Discharge for each Treatement episode completed ?'
                errors={!!errors.question7}
                helperText={errors?.question7?.message}
                register={register('question7', {
                  onChange: (e) =>
                    dispatch(setQuestion7(Number.parseInt(e.target.value))),
                })}
              />
              <FormInputRadio
                name='question8'
                control={control}
                options={QAOptions}
                label='8. Is the Participant Profile completed ?'
                errors={!!errors.question8}
                helperText={errors?.question8?.message}
                register={register('question8', {
                  onChange: (e) =>
                    dispatch(setQuestion8(Number.parseInt(e.target.value))),
                })}
              />
              <FormInputRadio
                name='question9'
                control={control}
                options={QAOptions}
                label='9. Substance Abuse Services Coordination Plan (CDC 1868) ?'
                errors={!!errors.question9}
                helperText={errors?.question9?.message}
                register={register('question9', {
                  onChange: (e) =>
                    dispatch(setQuestion9(Number.parseInt(e.target.value))),
                })}
              />
              <FormInputRadio
                name='question10'
                control={control}
                options={QAOptions}
                label='10. Do Notes indicate follow-up on needed services?'
                errors={!!errors.question10}
                helperText={errors?.question10?.message}
                register={register('question10', {
                  onChange: (e) =>
                    dispatch(setQuestion10(Number.parseInt(e.target.value))),
                })}
              />
              <FormInputRadio
                name='question11'
                control={control}
                options={QAOptions}
                label='11. Are school, work and vocational rehabilitation involvement noted ?'
                errors={!!errors.question11}
                helperText={errors?.question11?.message}
                register={register('question11', {
                  onChange: (e) =>
                    dispatch(setQuestion11(Number.parseInt(e.target.value))),
                })}
              />
              <FormInputRadio
                name='question12'
                control={control}
                options={QAOptions}
                disabled={true}
                label='12. Are medical and follow-up referrals noted ?'
              />
              <FormInputRadio
                name='question13'
                control={control}
                options={QAOptions}
                errors={!!errors.question13}
                helperText={errors?.question13?.message}
                label='13. Are legal and follow-up referrals noted ? (i.e court, parole, etc.)'
                register={register('question13', {
                  onChange: (e) =>
                    dispatch(setQuestion13(Number.parseInt(e.target.value))),
                })}
              />
              <FormInputRadio
                name='question14'
                control={control}
                options={QAOptions}
                errors={!!errors.question14}
                helperText={errors?.question14?.message}
                label='14. Is there documented face to face treatement contacts ?'
                register={register('question14', {
                  onChange: (e) =>
                    dispatch(setQuestion14(Number.parseInt(e.target.value))),
                })}
              />
              <FormInputRadio
                name='question15'
                control={control}
                options={QAOptions}
                label='15. Is the Discharge Summary completed ?'
                errors={!!errors.question15}
                helperText={errors?.question15?.message}
                register={register('question15', {
                  onChange: (e) =>
                    dispatch(setQuestion15(Number.parseInt(e.target.value))),
                })}
              />
              <Grid item xs={12} sm={6}>
                <FormInputText
                  name='exceptionComments'
                  type='text'
                  control={control}
                  multiline={true}
                  rows={3.5}
                  label='Exception Comments'
                  register={register('exceptionComments', {
                    onBlur: (e) =>
                      dispatch(setExceptionComments(e.target.value)),
                  })}
                />
                {/* <FormInputDropdown
                  name='reviewCreatedBy'
                  control={control}
                  options={qualityAssuranceReferenceData?.userList}
                  label='Review Created By'
                />
                <FormInputText
                  name='dateCreated'
                  control={control}
                  type='datetime-local'
                  label='Created Date'
                  shrink={true}
                  register={register('dateCreated', {
                    onChange: (e) => dispatch(setDateCreated(e.target.value)),
                  })}
                /> */}
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormInputText
                  type='text'
                  name='followUpComments'
                  control={control}
                  multiline={true}
                  rows={3.5}
                  label='Follow Up Comments'
                  register={register('followUpComments', {
                    onBlur: (e) =>
                      dispatch(setFollowUpComments(e.target.value)),
                  })}
                />
                {/* <FormInputDropdown
                  name='editedBy'
                  control={control}
                  options={qualityAssuranceReferenceData?.userList}
                  label='Edited By'
                />
                <FormInputText
                  name='dateEdited'
                  control={control}
                  type='datetime-local'
                  label='Edited Date'
                  shrink={true}
                  register={register('dateEdited', {
                    onChange: (e) => dispatch(setDateEdited(e.target.value)),
                  })}
                /> */}
              </Grid>
              <ButtonWrapper>
                <CancelButton variant='contained' onClick={handleClose}>
                  Cancel
                </CancelButton>
                <SaveButton
                  variant='contained'
                  onClick={handleSubmit(onSubmit)}
                >
                  Save
                </SaveButton>
              </ButtonWrapper>
            </Grid>
          </>
        )}
      </Dialog>
      <FormSuccess
        formSuccess={formSuccess}
        setFormSuccess={setFormSuccess}
        isNewForm={isNewQualityAssurance}
      />
    </>
  );
};

export default QualityAssuranceDialog;
